import { useState, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { Link, navigate } from "@reach/router";

import { useAppContext } from "libs/contextLib";
import axiosObj from "libs/axios";

import BigSpinner from "components/BigSpinner";

import { TEACHER_URLS } from "constants/urls";
import {
  PRIVACY_POLICY,
  TERMS_OF_USE,
  COMMON_ERROR,
  LOGGED_OUT_ERROR,
} from "constants/common";
import FACEBOOK_IMAGE from "assets/images/social-facebook.png";
import INSTAGRAM_IMAGE from "assets/images/social-instagram.png";
import TWITTER_IMAGE from "assets/images/social-twitter.png";

import "./apply.scss";

export default function Apply() {
  const {
    authenticateUser,
    authenticatedUser,
    updateErrorMessage,
  } = useAppContext();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [twitterId, setTwitterId] = useState("");
  const [facebookId, setFacebookId] = useState("");
  const [instagramId, setInstagramId] = useState("");

  const [progress, setProgress] = useState(0);
  const [submitting, setSubmitting] = useState();

  function submit(event) {
    setSubmitting(true);
    event.preventDefault();
    let patchData = {};
    let keys = [
      "email",
      "firstName",
      "lastName",
      "twitterId",
      "facebookId",
      "instagramId",
    ];
    keys.forEach((key) => {
      if (eval(key)) {
        patchData[key] = eval(key);
      }
    });

    if (!patchData) {
      navigate("/teach", { replace: true });
    } else {
      axiosObj.patch(TEACHER_URLS.REGISTER, patchData).then(
        (response) => {
          if (response.status && response.status === 200) {
            authenticateUser({ ...authenticatedUser, teacher: response.data });
            navigate("/teach", { replace: true });
          } else {
            console.log(response);
            updateErrorMessage(COMMON_ERROR);
            setSubmitting(false);
          }
        },
        (error) => {
          console.log(error);
          setSubmitting(false);
          if (error.response && error.response.status) {
            if (error.response.status === 401) {
              authenticateUser(null);
              updateErrorMessage(LOGGED_OUT_ERROR);
              navigate("/teach", { replace: true });
            } else if (error.response.status === 400) {
              try {
                const firstError = Object.values(error.response.data)[0][0];
                updateErrorMessage(
                  firstError.charAt(0).toUpperCase() + firstError.slice(1)
                );
              } catch {
                updateErrorMessage(COMMON_ERROR);
              }
            } else {
              updateErrorMessage(COMMON_ERROR);
            }
          } else {
            updateErrorMessage(COMMON_ERROR);
          }
        }
      );
    }
  }

  function next(event) {
    event.preventDefault();
    setProgress((progress) => progress + 1);
  }

  function back() {
    setProgress((progress) => progress - 1);
  }

  let currentForm;

  switch (progress) {
    case 0:
      currentForm = (
        <Form onSubmit={next}>
          <h3 className="name-email-header">Let's get to know you a little</h3>
          <Form.Group controlId="name" className="name-section">
            <Form.Label>
              <div className="name-formgroup-label">
                What should we call you?
              </div>
            </Form.Label>
            <Form.Row>
              <Col>
                <Form.Control
                  required
                  size="lg"
                  autoFocus
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="First name"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide your first name
                </Form.Control.Feedback>
              </Col>
              <Col>
                <Form.Control
                  required
                  size="lg"
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Last name"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide your last name
                </Form.Control.Feedback>
              </Col>
            </Form.Row>
          </Form.Group>
          <Form.Group controlId="email" className="email-section">
            <Form.Label>
              <div className="email-formgroup-label">Your email</div>
            </Form.Label>
            <Form.Control
              required
              size="lg"
              type="email"
              placeholder="me@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Form.Text muted>We promise not to spam you. Ever.</Form.Text>
            <Form.Control.Feedback type="invalid">
              Please provide your email
            </Form.Control.Feedback>
          </Form.Group>
          <Button className="continue-button" block size="lg" type="submit">
            CONTINUE
          </Button>
        </Form>
      );
      break;

    case 1:
      currentForm = (
        <>
          <Form onSubmit={submit}>
            <h3 className="social-accounts-header">Confirm your identity</h3>
            <div className="social-sub-heading">
              Connect at least one account where we can verify your identity as
              a trainer.
            </div>
            <Form.Group
              as={Row}
              controlId="instagram"
              className="social-section"
            >
              <Form.Label
                column
                xs={5}
                className="social-formgroup-label align-self-end"
              >
                <img
                  src={INSTAGRAM_IMAGE}
                  className="social-image"
                  alt="instagram logo"
                />
                Instagram
              </Form.Label>
              <Col>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>@</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    autoFocus
                    type="text"
                    value={instagramId}
                    onChange={(e) => setInstagramId(e.target.value)}
                    placeholder="username"
                  />
                </InputGroup>
              </Col>
            </Form.Group>

            <Form.Group
              as={Row}
              controlId="social-id"
              className="social-section"
            >
              <Form.Label
                column
                xs={5}
                className="social-formgroup-label align-self-end"
              >
                <img
                  src={FACEBOOK_IMAGE}
                  className="social-image"
                  alt="facebook logo"
                />
                Facebook
              </Form.Label>
              <Col>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>/</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="text"
                    value={facebookId}
                    onChange={(e) => setFacebookId(e.target.value)}
                    placeholder="youraccount"
                  />
                </InputGroup>
              </Col>
            </Form.Group>

            <Form.Group
              as={Row}
              controlId="social-id"
              className="social-section"
            >
              <Form.Label
                column
                xs={5}
                className="social-formgroup-label align-self-end"
              >
                <img
                  src={TWITTER_IMAGE}
                  className="social-image"
                  alt="twitter logo"
                />
                Twitter
              </Form.Label>
              <Col>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>@</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="text"
                    value={twitterId}
                    onChange={(e) => setTwitterId(e.target.value)}
                    placeholder="handle"
                  />
                </InputGroup>
              </Col>
            </Form.Group>

            <div className="mid-links">
              By continuing, I agree to the{" "}
              <Link to={"/tnc"}>{TERMS_OF_USE}</Link> &amp;{" "}
              <Link to={"/privacy-policy"}>{PRIVACY_POLICY}</Link>
            </div>
            <Button
              className="complete-registration-button"
              block
              size="lg"
              type="submit"
              disabled={submitting}
            >
              {submitting ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                </>
              ) : null}
              Complete Registration
            </Button>
          </Form>
          <Button
            className="bottom-link"
            variant="link"
            onClick={back}
            disabled={submitting}
          >
            Back
          </Button>
        </>
      );
      break;

    default:
      currentForm = null;
      console.log("This was unexpected");
  }

  useEffect(() => {
    if (
      authenticatedUser === null ||
      (authenticatedUser && authenticatedUser.teacher === undefined)
    ) {
      navigate("/teach");
    }
  });

  if (authenticatedUser === false) {
    return (
      <Container>
        <BigSpinner />
      </Container>
    );
  } else if (
    authenticatedUser === null ||
    (authenticatedUser && authenticatedUser.teacher === undefined)
  ) {
    return null;
  }

  return (
    <Container>
      <Row className="justify-content-center">
        <Col className="registration-container" xs={10} md={6}>
          {currentForm}
        </Col>
      </Row>
    </Container>
  );
}
